import { render, staticRenderFns } from "./ReferenceTagChipSelector.vue?vue&type=template&id=db46f484&scoped=true&"
import script from "./ReferenceTagChipSelector.vue?vue&type=script&lang=js&"
export * from "./ReferenceTagChipSelector.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceTagChipSelector.vue?vue&type=style&index=0&id=db46f484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db46f484",
  null
  
)

export default component.exports